
import { Component, Vue } from 'vue-property-decorator';
import OrderSearch from './components/OrderSearchCustom.vue';
import OrderList from './components/OrderList.vue';

@Component({
  name: 'orderServicerRefuse',
  components: {
    OrderSearch,
    OrderList
  }
})
export default class extends Vue {
  private isRefuseAcceptComplete = true;
}
